$(document).ready(function () {
  // COMPRA RÁPIDA
  $(document).on("click", "[data-add-kit-to-cart]", function () {
    const btn = $(this);
    $(btn).addClass("is-loading");
    const json = $(this).data("json");
    const quantitySelectorValue = parseInt(
      $(".form-input.quantity__input").val()
    );
    Shopify.queue = [];
    json.forEach((item) => {
      Shopify.queue.push({
        variantId: item.variant_id,
        quantity: item.quantity * quantitySelectorValue,
      });
    });
    Shopify.moveAlong = function () {
      if (Shopify.queue.length) {
        var request = Shopify.queue.shift();
        let dataForm =
          "quantity=" + request.quantity + "&id=" + request.variantId;
        var params = {
          type: "POST",
          url: "/cart/add.js",
          data: dataForm,
          dataType: "json",
          success: function (line_item) {
            Shopify.moveAlong();
          },
          error: function (XMLHttpRequest, textStatus) {
            showWarning("Erro ao adicionar");
          },
        };
        $.ajax(params);
      } else {
        $(btn).removeClass("is-loading");
        $(".content-compra-rapida").removeClass("is-loading");
        $(".content-compra-rapida").find("loading-overlay--custom").remove();
        $("body").removeClass("compra-rapida-aberto");
        Shopify.getCart((cartTotal) => {
          $("body").addClass("cart-sidebar-show");
          $("body").find("[data-cart-count]").text(cartTotal.item_count);
          window.updateCart(cartTotal);
        });
      }
    };
    Shopify.moveAlong();
  });
  $(".btn-quantity").on("click", function () {
    var inputElement = $(this).siblings(".qtd-input");
    var currentValue = parseInt(inputElement.val());
    var maxInventory = parseInt(inputElement.attr("data-inventory"));
    if ($(this).hasClass("plus")) {
      if (currentValue < maxInventory) {
        inputElement.val(currentValue + 1).trigger("change");
      }
    } else if ($(this).hasClass("minus")) {
      if (currentValue > 0) {
        inputElement.val(currentValue - 1).trigger("change");
      }
    }
  });
  $(".qtd-input").on("change", function () {
    var inputValue = parseInt($(this).val());
    var maxInventory = parseInt($(this).attr("data-inventory"));
    if (inputValue < 0) {
      $(this).val(0);
    } else if (inputValue > maxInventory) {
      $(this).val(maxInventory).trigger("change");
    }
  });
  $(".products-carousel").on("click", function (e) {
    if(e.target.classList.contains("btn-quantity")) {
      const btnQuantity = e.target
      const inputElement = btnQuantity.parentElement.querySelector(".quantity__input");
      var currentValue = parseInt(inputElement.value);
      
      if(btnQuantity.classList.contains("plus")) {
        inputElement.value = currentValue + 1;
        inputElement.dispatchEvent(new Event("change"))
      }
      if(btnQuantity.classList.contains("minus") && currentValue > 1) {
        inputElement.value = currentValue - 1;
        inputElement.dispatchEvent(new Event("change"))
      }
    }
  });

  if ($(document.body).hasClass("template-product")) {
    window.kitProducts = [];
    window.validateProductKit = function () {
      let hasNullValue = false;
      window.kitProducts.forEach((item, index) => {
        if (!item) hasNullValue = true;
      });
  
      if (!hasNullValue && window.kitProducts.length == $('.selection-wrapper').data('kit-size')) {
        $("#add-kit-to-cart").prop("disabled", false);
      } else 
        $("#add-kit-to-cart").prop("disabled", true);
    };

    $('.selection-wrapper .dropdown-product-kit input[type="checkbox"]').on(
      "change",
      function (e) {
        if ($(this).is(":checked")) {
          $(`.selection-wrapper input[type="checkbox"]`)
            .not(this)
            .prop("checked", false);
        }
      }
    );

    $('.selection-wrapper input[type="radio"]').on("change", function (event) {
      // Fecha os seletores abertos
      $(`.selection-wrapper input[type="checkbox"]`).prop("checked", false);

      // Clona o item para dentro do label para visualização do produto escolhido
      const index = $(this).data("index");
      const incipient = $(event.currentTarget)
        .closest(".product-kit-selection")
        .find("#target" + index);
      const item = $(event.currentTarget)
        .closest(".dropdown-product-item")
        .clone(false);

      incipient.children().remove();
      item.appendTo(incipient);

      if (
        $(event.currentTarget)
          .closest(".product-kit-selection")
          .children("label.is-empty").length
      ) {
        $(event.currentTarget)
          .closest(".product-kit-selection")
          .children("label.is-empty")
          .removeClass("is-empty");
      }

      window.kitProducts[index] = $(this).val();
      window.validateProductKit();
    });

    $("#add-kit-to-cart").on("click", function (event) {
      $(event.currentTarget).addClass("is-loading");

      const queue = [...window.kitProducts];
      Shopify.moveAlong = function () {
        if (queue.length) {
          var request = queue.shift();
          let dataForm = "quantity=" + 1 + "&id=" + request;
          var params = {
            type: "POST",
            url: "/cart/add.js",
            data: dataForm,
            dataType: "json",
            success: function (line_item) {
              Shopify.moveAlong();
            },
            error: function (XMLHttpRequest, textStatus) {
              showWarning("Erro ao adicionar", 2000);
            },
          };
          $.ajax(params);
        } else {
          $(event.currentTarget).removeClass("is-loading");
          Shopify.getCart((cartTotal) => {
            $("body").addClass("cart-sidebar-show");
            $("body").find("[data-cart-count]").text(cartTotal.item_count);
            window.updateCart(cartTotal);
          });
        }
      };
      Shopify.moveAlong();
    });
  }

  const trackingAnchors = document.querySelectorAll(`a[href="/pages/rastreio"]`)
  const mobileMenu = document.querySelector(".mobileMenu-toggle");

  function openTrackingSidebar(e) {
    e.preventDefault();
    $("body").addClass("tracking-sidebar-show")
    $("body").removeClass("menu_open")
  }

  trackingAnchors.forEach((trackingAnchor) => {
    trackingAnchor.removeEventListener("click", openTrackingSidebar)
    trackingAnchor.href = "#"
    trackingAnchor.addEventListener("click", openTrackingSidebar)
  })

  const callback = (mutationsList, observer) => {
    for (const mutation of mutationsList) {
      if (mutation.type === 'childList') {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === 1 && node.classList.contains('header__inline-menu')) {
            const menuAnchors = node.querySelectorAll(".menu-lv-item a")
            const tracking = Array.from(menuAnchors).find(node => node.textContent == "Rastrear Pedido");
            tracking.removeEventListener("click", openTrackingSidebar)
            tracking.addEventListener("click", openTrackingSidebar)
          }
        });
      }
    }
  };

  // Cria um novo observador de mutação e passa a função de callback
  const observer = new MutationObserver(callback);

  // Inicia a observação no nó de destino
  observer.observe(document.body, { childList: true, subtree: true });


  const trackingSidebar = document.querySelector("#halo-tracking-sidebar")
  trackingSidebar.addEventListener("click", (e) => e.stopPropagation())

  const backgroundOverlay = document.querySelector(".background-overlay");
  const trackingSidebarCloseButton = document.querySelector("#halo-tracking-sidebar .halo-sidebar-close")

  backgroundOverlay.addEventListener("click", (e) => $("body").removeClass("tracking-sidebar-show"))
  trackingSidebarCloseButton.addEventListener("click", (e) => $("body").removeClass("tracking-sidebar-show"))




  const cardSpacingObserver = new MutationObserver(function(mutationsList, observer) {
    for (const mutation of mutationsList) {
      if (mutation.type === 'childList') {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === 1 && node.classList.contains('product')) {
            const ps = node.querySelectorAll("p")
            ps.forEach((p) => {
              if(p.textContent.includes('[esp]')) {
                p.style.opacity = "0";
              }
            })

          }
        })
      }
    }
  })

  cardSpacingObserver.observe(document.body, { childList: true, subtree: true });

  const prodCardDescParagraphs = document.querySelectorAll(".metafield-rich_text_field p")
  
  prodCardDescParagraphs.forEach((p) => {
    if(p.textContent.includes('[esp]')) {
      p.style.opacity = "0";
    }
  })

  const mobileBottomBar = document.querySelectorAll(".halo-sticky-toolbar-mobile a")
  mobileBottomBar[2].addEventListener("click", (e) => {
    e.preventDefault();

    const compraRapida = document.querySelector("#compra-rapida-trigger")
    compraRapida.dispatchEvent(new Event("click"))
  })

});
